var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttackerAsset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Attacker and severity"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtract",
    filter: "url(#filter0_d_22532_82185)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2865 22.5332C30.2865 24.4051 29.4896 25.7668 28.2305 26.7371C32.0997 28.399 34.7969 31.3914 34.7969 35.7193C34.7969 37.9565 27.6729 37.9565 19.9719 37.9565C12.2708 37.9565 5.21826 37.9565 5.21826 35.7193C5.21826 31.4092 7.82294 28.445 11.595 26.7827C10.4005 25.8097 9.65865 24.4346 9.65865 22.5331C9.65865 18.5127 15.4859 8.35471 20.0517 8.35498C24.6175 8.35525 30.2865 18.8757 30.2865 22.5332ZM19.6645 21.4006C19.8086 21.0923 19.6635 20.7417 19.383 20.5492L16.2254 18.3818C15.9452 18.1895 15.5666 18.1801 15.3302 18.4244C15.2996 18.456 15.2695 18.4886 15.2401 18.5221C14.2618 19.6361 14.3653 21.3267 15.4715 22.2982C16.5776 23.2696 18.2674 23.154 19.2458 22.04C19.4192 21.8425 19.5586 21.627 19.6645 21.4006ZM20.3188 21.4006C20.1747 21.0923 20.3197 20.7417 20.6003 20.5492L23.7578 18.3818C24.0381 18.1895 24.4167 18.1801 24.6531 18.4244C24.6702 18.442 24.6871 18.46 24.7038 18.4782C24.717 18.4926 24.7301 18.5073 24.7431 18.5221C25.7215 19.6361 25.618 21.3267 24.5118 22.2982C23.4057 23.2696 21.7158 23.154 20.7375 22.04C20.5641 21.8425 20.4247 21.627 20.3188 21.4006Z",
    fill: "url(#paint0_linear_22532_82185)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22532_82185",
    x: 0.718262,
    y: 0.85498,
    width: 38.5786,
    height: 38.6016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.807843 0 0 0 0 0.803922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22532_82185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22532_82185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22532_82185",
    x1: 20.0076,
    y1: 8.35498,
    x2: 20.0076,
    y2: 37.9565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#510D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B71D18"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttackerAsset);
export default __webpack_public_path__ + "static/media/attacker_asset.313273933cc86ff114b34bb486ae5fde.svg";
export { ForwardRef as ReactComponent };